import { useState } from "react";
import { useI18n } from "react-simple-i18n";
import { styled } from "@mui/material/styles";
import { Box, Stack, Typography } from "@mui/material";

import { toastMessage } from "../../utils";
import { restApi } from "../../provider/restApi";
import { Layout } from "../../components/layout/layout";
import { Divider } from "../../components/divider/divider";
import { FirstButton } from "../../components/buttons/buttons";
import { TransparentTextField } from "../../components/inputs/textfield";
import { GlobalFirstSection, GlobalSpacing } from "../../components/layout/styles";
import { apiNotification } from "../../services/apiNotification";
import { initUserData, useGlobalContext } from "../../provider";
import { useCustomNavigate } from "../../provider/navigate";

interface LogInData {
	email: string;
	password: string;
	name?:"";
	errorEmail: boolean
	errorPassword: boolean
}

const initLogInData: LogInData = {
	email: "",
	password: "",
	name:"",

	errorEmail: false,
	errorPassword: false,
}

const LogIn = () => {
	const { t } = useI18n();
	const { navigate, customNavigate } = useCustomNavigate();
	const [, { dispatch }]: GlobalContextType = useGlobalContext();
	const [logInData, setLogInData] = useState<LogInData>(initLogInData);

	const updateLogInData = (data: Partial<LogInData>) => {
		setLogInData({ ...logInData, ...data });
	}

	const checkValidate = (data: LogInData): boolean => {
		if (!data.email) return false;
		if (!data.password) return false;

		return true;
	}

	const handleLogIn = async () => {
		try {
			const validate = checkValidate(logInData);

			if (!validate) {
				updateLogInData({
					errorEmail: !logInData.email,
					errorPassword: !logInData.password,
				})

				return false;
			}
			const isAuthorized:any="true";
			const data: Loginprops = {
				email: logInData.email,
				password: logInData.password,
			}

			dispatch({ loading: true });

			const resData = await restApi.login(data);
			console.log(resData);	
			localStorage.setItem("name", resData.userData.name)
			localStorage.setItem("email", resData.userData.email)
			localStorage.setItem("isAuthorized", isAuthorized)
			localStorage.setItem("UserId",resData.userData.id);
			dispatch({
				loading: false,
				loginStatus: true,
				authToken: resData.token,
				userData: resData.userData,
			})

			navigate("/browseCourse");
			toastMessage("success", "Login successed!");
		} catch (error) {
			dispatch({
				loading: false,
				loginStatus: false,
				authToken: "",
				userData: initUserData,
			})

			apiNotification(error, "Login failed!");
		}
	}

	return (
		<Layout>
			<GlobalSpacing>
				<LogInWrapper>
					<LogInForm>
						<Typography variant="h2">
							{t("login.title")}
						</Typography>

						<Stack flexDirection="column" gap={1.5}>
							<TransparentTextField required={true}
								variant="standard"
								label={t("inputLabels.email")}
								value={logInData.email}
								onChange={({ target }: any) => { updateLogInData({ email: target.value, errorEmail: false }) }}
								error={logInData.errorEmail}
							/>

							<TransparentTextField required={true}
								variant="standard"
								label={t("inputLabels.password")}
								value={logInData.password} type="password"
								onChange={({ target }: any) => { updateLogInData({ password: target.value, errorPassword: false }) }}
								error={logInData.errorPassword}
							/>
						</Stack>

						<FirstButton onClick={handleLogIn}>
							<Typography variant="body1">{t("buttons.login")}</Typography>
						</FirstButton>

						<Divider />
						<DonthaveAccount>
							<Typography variant="body1" component="h6">{t("login.dontHaveAccount")}</Typography>
							<Typography variant="body1" onClick={customNavigate('/register')}>{t("buttons.signup")}</Typography>
							<Typography variant="body1" component="h6">{t("login.forfree")}</Typography>
						</DonthaveAccount>
					</LogInForm>
				</LogInWrapper>
			</GlobalSpacing>
		</Layout >
	)
}

const LogInWrapper = styled(GlobalFirstSection)(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	justifyContent: "center",
	alignItems: "center",
	padding: "50px 0px",
}))

const LogInForm = styled(Box)(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	justifyContent: "center",
	textAlign: "center",
	gap: theme.spacing(4),

	maxWidth: 500,
	width: "100%",
}))

const DonthaveAccount = styled(Box)(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	alignItems: "center",
	gap: theme.spacing(1),

	p: {
		cursor: "pointer",
		color: theme.palette.common.thirdColor,
	}
}))

export { LogIn }